// api/familyApi.js
import { API_URL } from '../config/apiConfig';
import axios from 'axios';


/**
 * Fetches all family members for the current user
 * @returns {Array} List of family members
 */
export const getFamilyMembers = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/user/family-members`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching family members:', error);
        return [];
    }
};

/**
 * Adds a new family member
 * @param {string} fullName - The full name of the family member
 * @param {string} dateOfBirth - The date of birth (YYYY-MM-DD format)
 * @param {string} sex - The sex (male/female)
 * @returns {Object} The newly created family member
 */
export const addFamilyMember = async (fullName, dateOfBirth, sex) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.post(`${API_URL}/user/family-members`,
            {
                fullName,
                dateOfBirth,
                sex
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data;
    } catch (error) {
        console.error('Error adding family member:', error);
        throw error;
    }
};

/**
 * Deletes a family member
 * @param {number} id - The ID of the family member to delete
 * @returns {boolean} True if successfully deleted
 */
export const deleteFamilyMember = async (id) => {
    try {
        const token = localStorage.getItem('token');
        await axios.delete(`${API_URL}/user/family-members/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });

        return true;
    } catch (error) {
        console.error('Error deleting family member:', error);
        throw error;
    }
};

/**
 * Fetches family members for a specific user (for affiliates)
 * @param {number} userId - The ID of the user
 * @returns {Array} List of family members
 */
export const getAffiliateFamilyMembers = async (userId) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_URL}/user/family-members/${userId}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error fetching affiliate family members:', error);
        return [];
    }
};

export default {
    getFamilyMembers,
    addFamilyMember,
    deleteFamilyMember,
    getAffiliateFamilyMembers
};